<script setup lang="ts">
import Icon from '@components/Icon.vue';
import { ref } from 'vue';
import Typography from '@components/Typography.vue';
import TrustpilotWidget from '@components-molecules/TrustpilotWidget.vue';
import { transchoice } from '@elements/translation';
import IconLogo from '@icons/ph_logo.svg';

const companyName = ref<string>(window.COMPANY_NAME);
</script>

<template>
  <div class="offer-contact-promises">
    <div class="offer-contact-promises__reinsurance">
      <Icon :svg="IconLogo" width="60" height="32" />

      <Typography
        variant="body"
        color="gray-darker"
      >
        {{ transchoice('offer.contact.promises.title', { company_name: companyName }) }}
      </Typography>
    </div>

    <TrustpilotWidget
      class="offer-contact-promises__trustpilot"
      type="trust_score"
      width="250"
    />
  </div>
</template>
